import React from "react";
import { Card, CardContent, Box, Skeleton, useTheme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme, isMobile }) => ({
  width: isMobile ? "100%" : "417px",
  minWidth: isMobile ? "290px" : "auto",
  background: "#FFFFFF",
  boxShadow: "0px 10px 26px rgba(0, 0, 0, 0.04)",
  borderRadius: isMobile ? "12px" : "16px",
  overflow: "visible",
  fontFamily: "'Red Hat Display', sans-serif",
  maxWidth: isMobile ? "100%" : "100%",
}));

const LifeCardSkeletonV2 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <StyledCard isMobile={isMobile}>
        <CardContent
          sx={{
            padding: isMobile ? "12px" : "16px",
            "&:last-child": { paddingBottom: isMobile ? "16px" : "20px" },
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={isMobile ? "156px" : "217px"}
            sx={{ borderRadius: isMobile ? "12px" : "16px", marginBottom: isMobile ? "14px" : "18px" }}
            animation="wave"
          />

          <Skeleton variant="text" width="100%" height={isMobile ? "36px" : "52px"} sx={{ marginBottom: isMobile ? "8px" : "10px" }} animation="wave" />

          <Skeleton variant="rectangular" width="100%" height={isMobile ? "10px" : "12px"} sx={{ borderRadius: "20px", marginBottom: isMobile ? "44px" : "54px" }} animation="wave" />

          <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? "6px" : "8px", marginBottom: isMobile ? "16px" : "20px" }}>
            {[0, 1, 2].map((i) => (
              <Box key={i} sx={{ display: "flex", alignItems: "center", gap: isMobile ? "8px" : "10px", flex: 1 }}>
                {i > 0 && <Box sx={{ width: "1px", height: isMobile ? "32px" : "38px", background: "#E8E8E8", flexShrink: 0 }} />}
                <Skeleton variant="rounded" width={isMobile ? "28px" : "32px"} height={isMobile ? "28px" : "32px"} sx={{ borderRadius: "8px", flexShrink: 0 }} animation="wave" />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="40px" height="14px" animation="wave" />
                  <Skeleton variant="text" width="60px" height="14px" animation="wave" />
                </Box>
              </Box>
            ))}
          </Box>

          <Skeleton variant="rectangular" width="100%" height="1px" sx={{ marginBottom: isMobile ? "16px" : "20px" }} animation="wave" />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Skeleton variant="rectangular" width={isMobile ? "80px" : "100px"} height={isMobile ? "32px" : "40px"} sx={{ borderRadius: "10px" }} animation="wave" />
          </Box>
        </CardContent>
      </StyledCard>
    </Box>
  );
};

export default LifeCardSkeletonV2;
